import { jobsNudgeRelevant } from '../statics/lists'
import { Data } from '../../../interfaces/ApolloResponse.interface'

export const hasPositionNudgeRelevant = (state: Data) =>
  jobsNudgeRelevant.includes(state.debtors.primary.currentEmployment.position)
